import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BaseComponent } from '../../component-base';
import { AuthForignerService } from 'src/app/shared/services/authentication/authforigner.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { CacheService } from 'src/app/shared/services/cashe-service';

@Component({
  selector: 'app-registerusingforigner',
  templateUrl: './registerusingforigner.component.html',
  styleUrls: ['./registerusingforigner.component.css']
})
export class RegisterusingforignerComponent extends BaseComponent{
  form: FormGroup;

  constructor(private formBuilder: FormBuilder,
    private authservice:AuthForignerService,public translate: TranslateService,
    public override router: Router
    )
  {
    super();
  }
  ngOnInit() {   
    this.initForm();
  }
  initForm() {
    this.form = this.formBuilder.group({
      email: ['']
    },
    );
  }

  register(){
    this.authservice.Register(this.form.controls["email"].value).subscribe(result=>{
      if (result.value && result.value!="email not existed in sadaf") {
        this.done(this.translate.instant('shared.doneSuccessfully') );
        CacheService.setOtp(result.value);
        CacheService.setRegisteredEmail(this.form.controls["email"].value);
        this.router.navigate(['/auth/verifyotp']);
      }
      else 
      {
        this.failed(this.translate.instant(result.value) );
      }
    })
  }
}
